// Images
import crescentHero from "../images/CRESCENT_HERO.webp";
import crescentFonts from "../images/CRESCENT_FONTS.png";
import crescentPoster from "../images/CRESCENT_POSTER.webp";
import cover from "../images/cover.jpg";
import streetcultback from "../images/street-culture-back.jpg";
import verbumproject from "../images/verbum-project-image.webp";
import verbumhistory from "../images/verbum-history-img.jpg";
import verbumcard from "../images/verbum-test-card.jpg";
import aneteprojects from "../images/aneteprojects.jpg";
import anetelanding from "../images/anetelanding.jpg";
import portfolioview from "../images/portfolio-project-image.jpg";
import portfolioskills from "../images/portfolio_skills.jpg";
import trackeaseitem from "../images/trackease-item.webp";
import trackeasehome from "../images/trackease-home.webp";
import boomboxhome from "../images/boombox-home.webp";
import boomboxhsongs from "../images/boombox-songs.webp";
import studlylanding from "../images/studly-landing.webp";
import studlyfooter from "../images/studly-footer.webp";
import ewgarticles from "../images/ewg-articles.webp";
import ewgdonate from "../images/ewg-donate.webp";
import brandingtypograpgy from "../images/branding-typography.webp";
import brandinglogos from "../images/branding-logos.webp";
import arrow from "../images/arrow_svg.svg";
import arrowdiag from "../images/arrow_diag_svg.svg";
import rmlogo from "../images/RM-logo.svg";

// Videos
import streetcultvideo from "../images/street_culture_video.mp4";
import aneteportvideo from "../images/anete_portfolio_video.mp4";
import portfoliovido from "../images/portfolio_video.mp4";
import trackeasevideo from "../images/trackease-video.mp4";
import boomboxvideo from "../images/boombox-video.mp4";
import studylvideo from "../images/studly-video.mp4";
import ewgvideo from "../images/ewg-video.mp4";
import motionvideoshort from "../images/motion-video-short.mp4";
import brandingvideo from "../images/branding-video.mp4";

export const media = {
  crescentHero,
  crescentFonts,
  crescentPoster,
  cover,
  streetcultback,
  streetcultvideo,
  verbumproject,
  verbumhistory,
  verbumcard,
  aneteportvideo,
  aneteprojects,
  anetelanding,
  portfoliovido,
  portfolioview,
  portfolioskills,
  trackeaseitem,
  trackeasevideo,
  trackeasehome,
  boomboxhome,
  boomboxhsongs,
  boomboxvideo,
  studlylanding,
  studylvideo,
  studlyfooter,
  ewgarticles,
  ewgvideo,
  ewgdonate,
  motionvideoshort,
  brandingvideo,
  brandingtypograpgy,
  brandinglogos,
  arrow,
  arrowdiag,
  rmlogo,
};
